import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Shop', path: '/shop' },
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'FAQ & Care', path: '/faq' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-cream/90 backdrop-blur-md border-b border-cream-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiFeather} className="text-3xl text-botanical" />
              <span className="font-serif text-2xl font-semibold text-botanical-dark">RootRoom</span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-clay ${
                  isActive(link.path) ? 'text-clay border-b-2 border-clay pb-1' : 'text-botanical-dark'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <button className="text-botanical-dark hover:text-clay transition-colors relative">
              <SafeIcon icon={FiIcons.FiShoppingCart} className="text-xl" />
              <span className="absolute -top-2 -right-2 bg-clay text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">2</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-botanical-dark hover:text-clay focus:outline-none"
            >
              <SafeIcon icon={isOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-cream border-b border-cream-dark">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive(link.path) ? 'text-clay bg-cream-dark' : 'text-botanical-dark hover:text-clay hover:bg-cream-dark'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;